import { Badge, BadgeStatus } from '@aslanpay/portal-common-lib';

import {
  SalaryDiscrepancyFixabilityValues,
  SalaryDiscrepancyReasonValues,
} from 'app/constants/salaryReconciliations';

import {
  SalaryDiscrepancyFixability,
  SalaryDiscrepancyReason,
} from 'app/types/salaryReconciliations';

/**
 * @description Describes why a salary accrual discrepancy happened, or a dash when it has not been explained.
 */
export const formatDiscrepancyReason = (reason?: SalaryDiscrepancyReason | null): string => {
  if (reason) {
    return SalaryDiscrepancyReasonValues[reason] ?? reason;
  }
  return '-';
};

/**
 * @description Shows whether a salary adjustment would fix a discrepancy, or a dash when that is not known.
 */
export const renderFixability = (fixability?: SalaryDiscrepancyFixability | null) => {
  if (fixability) {
    const value = SalaryDiscrepancyFixabilityValues[fixability];
    return (
      <Badge
        value={value?.value ?? fixability}
        status={(value?.color ?? 'created') as BadgeStatus}
      />
    );
  }
  return '-';
};
